const counters: { [index: string]: number } = {};

export default function uniqueId(prefix: string, skipAndTakeThisIdInstead?: string) {
    if (skipAndTakeThisIdInstead) {
        return skipAndTakeThisIdInstead;
    }

    if (counters[prefix] === undefined) {
        counters[prefix] = 0;
    }

    return prefix + counters[prefix]++;
}
